import { render, staticRenderFns } from "./OnrampNavigation.vue?vue&type=template&id=578b2447&"
import script from "./OnrampNavigation.vue?vue&type=script&lang=ts&"
export * from "./OnrampNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./OnrampNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports